module.exports = __webpack_public_path__ + "img/icon-wishlist.f65a58ca.svg";